import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import ComicCard from "@/components/feature/ComicCard";
import { comics } from "@/mocks/comics";

const filters = ["全部", "热血", "搞笑", "日常", "治愈", "悬疑", "奇幻", "校园", "科幻"];

export default function List() {
  const [params] = useSearchParams();
  const initial = params.get("c") || "全部";
  const [active, setActive] = useState<string>(initial);

  const filtered = useMemo(
    () => (active === "全部" ? comics : comics.filter((c) => c.category === active)),
    [active],
  );

  return (
    <Layout>
      <title>追更榜单 - 配快乐水一口气看完的热门漫画推荐 | 可乐漫画</title>
      <meta name="description" content="可乐漫画追更榜单，编辑部每周精选热门漫画，热血、搞笑、日常、治愈、悬疑应有尽有，配上一杯快乐水，追更配零食，周末放松摸鱼必备。" />
      <meta name="keywords" content="可乐漫画,追更榜单,热门漫画推荐,快乐水组合,肥宅快乐套餐" />
      <link rel="canonical" href="https://snackview.github.io/list" />
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: "可乐漫画追更榜单",
          description: "编辑部每周精选的热门漫画推荐合集",
          url: "https://snackview.github.io/list",
          itemListElement: comics.map((c, i) => ({
            "@type": "ListItem",
            position: i + 1,
            name: c.title,
          })),
        })}
      </script>

      {/* 页头 */}
      <section className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-sm text-foreground-500">
            <a href="/" className="hover:text-primary-600">首页</a>
            <i className="ri-arrow-right-s-line" style={{ width: 16, height: 16 }} />
            <span className="text-foreground-800">追更榜单</span>
          </nav>
          <h1 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">追更榜单</h1>
          <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
            编辑部每周精选热门漫画，配上一杯快乐水，一口气看到最新话。肥宅快乐套餐已备好，选一部开始吧。
          </p>
        </div>
      </section>

      {/* 筛选 */}
      <section className="mx-auto max-w-7xl px-4 py-8 md:px-6">
        <div className="flex flex-wrap items-center gap-2 rounded-full border border-background-200 bg-background-50 p-1">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`rounded-full px-4 py-2 text-sm whitespace-nowrap transition-colors ${
                active === f ? "bg-primary-500 font-medium text-background-50" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {filtered.map((c, i) => (
            <ComicCard key={c.id} comic={c} rank={active === "全部" ? i + 1 : undefined} />
          ))}
        </div>
      </section>
    </Layout>
  );
}